/**
 *
 * Asynchronously loads the component for SignUpWrapper
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { AuthPageLoading } from 'components/AuthPageLoading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "SignUpWrapper" */),
  loading: <AuthPageLoading />
})
